import React from "react";
import type { CommandViewResponse, MapMarkerDto } from "../../lib/floorStackApi.js";

const ICON_FILL: Record<string, string> = {
  location: "#3ec1ff",
  camera: "#65f088",
  aed: "#ff5b6d",
  exit: "#65f088",
};

interface Props {
  data: CommandViewResponse;
  visible: boolean;
}

export default function LocationLayer({ data, visible }: Props): React.ReactElement | null {
  if (!visible) return null;
  const cps: MapMarkerDto[] = data.markers.filter((m) => ["location", "camera", "aed", "exit"].includes(m.marker_type));
  if (cps.length === 0) return null;
  return (
    <g data-layer="locations" pointerEvents="none">
      {cps.map((m) => (
        <g key={m.id} transform={`translate(${m.position_x}, ${m.position_y})`}>
          <circle r={11} fill={ICON_FILL[m.marker_type] ?? "#3ec1ff"} stroke="rgba(0,0,0,0.45)" strokeWidth={1.5} />
          {/* SENTRY logo for 地點 (location); single-letter glyph for
              the other marker types. m.marker_type[0] was overloaded —
              both "location" and "camera" start with C, so the old
              indicator was ambiguous; this swap also disambiguates. */}
          {m.marker_type === "location" ? (
            <image href="/sentry-icon.svg" x={-7} y={-7} width={14} height={14} />
          ) : (
            <text x={0} y={4} fontSize={9} fontWeight={700} textAnchor="middle" fill="#0b0d10">
              {m.marker_type[0].toUpperCase()}
            </text>
          )}
          {m.label && (
            <text x={16} y={4} fontSize={11} fill="rgba(255,255,255,0.85)">{m.label}</text>
          )}
        </g>
      ))}
    </g>
  );
}
